/** @format */

import {
	AppProductReviewState,
	ProductReviewAnalyticsService,
	ProductReviewDrawerType,
	SelectedProductReviewsProsCons,
	cleanReviewFilterRatings,
	openProductReviewDrawer,
	selectProductReviewCons,
	selectProductReviewCount,
	selectProductReviewPros,
	selectSelectedFeature,
	setSelectedFeature
} from '@product-reviews/data-access';
import { Component, input } from '@angular/core';

import { CommonModule } from '@angular/common';
import { FeatureLabelPipe } from '../pipes/feature-label.pipe';
import { ProductReviewProsConsType } from 'libs/product-reviews/data-access/src/lib/model/product-review-pros-cons.enum';
import { ReviewChipsModule } from '../review-chips/review-chips.module';
import { Store } from '@ngrx/store';

@Component({
	selector: 'product-reviews-ai-pros-cons',
	standalone: true,
	imports: [CommonModule, FeatureLabelPipe, ReviewChipsModule],
	templateUrl: './review-ai-pros-cons.component.html',
	styleUrl: './review-ai-pros-cons.component.scss'
})
export class ReviewAiProsConsComponent {
	isDrawer = input(false);

	constructor(
		private readonly store: Store<AppProductReviewState>,
		private readonly analyticsService: ProductReviewAnalyticsService
	) {}

	pros$ = this.store.select(selectProductReviewPros);
	cons$ = this.store.select(selectProductReviewCons);
	reviewCount$ = this.store.select(selectProductReviewCount);
	selected$ = this.store.select(selectSelectedFeature);

	selectProFeature(feature: string, currentFeature: SelectedProductReviewsProsCons) {
		this.selectFeature({ feature, type: ProductReviewProsConsType.PRO }, currentFeature);
	}

	selectConFeature(feature: string, currentFeature: SelectedProductReviewsProsCons) {
		this.selectFeature({ feature, type: ProductReviewProsConsType.CON }, currentFeature);
	}

	selectFeature(
		selectedFeature: SelectedProductReviewsProsCons,
		currentFeature: SelectedProductReviewsProsCons
	) {
		if (selectedFeature.feature === currentFeature?.feature) {
			this.store.dispatch(setSelectedFeature({ selectedFeature: null }));
			this.store.dispatch(cleanReviewFilterRatings());
		} else {
			this.store.dispatch(setSelectedFeature({ selectedFeature }));
		}

		if (!this.isDrawer()) {
			this.store.dispatch(
				openProductReviewDrawer({ drawerType: ProductReviewDrawerType.REVIEWS })
			);
		}

		this.trackChipEvent({
			type: selectedFeature.type,
			name: selectedFeature.feature
		});
	}

	private trackChipEvent({ type, name }) {
		const payload = {
			event: 'RatingsAndReviewsInteractions',
			value: 'Filter',
			details: `${type}:${name}`
		};

		this.analyticsService.fireReviewAnalytics<{ [key: string]: string }>({
			name: 'multiUseAnalyticsEvent',
			payload
		});
	}
}
